/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum VerticalLayoutOption {
    Top = 0,
    Center = 1,
    Bottom = 2,
    Stretch = 3,
}
